type FlavorType = 'standard';

const flavor: FlavorType = 'standard';

export const environment = {
  production: true,
  flavor: flavor,
  sentryDsn: 'https://681fc57a274e47909618a81a52a573c3@o4504723517800448.ingest.sentry.io/4504723581435904',
  allowSentry: false,
  seatingLayoutHash: '676746a1634db9cae2b0a61736c5849e',
  i18nHash: '40f34dc75e034395c1cc2e37a76d51b6',
  defaultLanguage: 'en',
  allowLogging: true,
  usePaymentEmulator: false,
  useApiEmulator: false,
  useGeoEmulator: false,
  canChangeLanguage: true,
  allowPixelTracking: false,
  isRunningInEmbeddedMode: false,
  barionPixelId: null,
  shareUrl: 'https://sandbox.in-time.hu/e',
  apiGatewayUrl: 'https://in-time-api-gateway-9llk7a74.ew.gateway.dev',
  firebase: {
    apiKey: 'AIzaSyAC_MPK5_a7nNqKDolyRwmGAJBgnssp2K4',
    authDomain: 'in-time-fa9b7.firebaseapp.com',
    databaseURL: 'https://in-time-fa9b7.firebaseio.com',
    projectId: 'in-time-fa9b7',
    storageBucket: 'in-time-fa9b7.appspot.com',
    messagingSenderId: '752293627744',
    appId: '1:752293627744:web:53835ceb286d9bf1730005',
    measurementId: 'G-TVFJ99S7JX',
    storageApiUrl: 'https://storage.googleapis.com',
  }
};
